module.exports = __webpack_public_path__ + "img/experience@2x (1).554de561.png";